import * as React from 'react';
import i18n from 'i18n';
import styles from 'views/Analytics/Placeholder/AnalyticsPlaceholder.module.css';
import clsx from 'clsx';
import BzmIcon from '../../../components/icons/BzmIcon';

const AnalyticsPlaceholder = () => {
  return (
    <div className={clsx(styles.AnalyticsPlaceholder, 'd-flex justify-content-center align-items-center')}>
      <div className="text-center">
        <BzmIcon variant={'icon-bzm-chart-bar'} className={styles.ChartIcon} />
        <h3 className="font-size-xjb">{i18n.t('analytics:placeholder.title')}</h3>
        <div className="p-2 w-100 bd-highlight text-center" style={{ maxWidth: '280px' }}>
          <p> {i18n.t('analytics:placeholder.message')}</p>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsPlaceholder;
